import React, { useContext, useState } from 'react'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { JobDocumentsContext } from 'stores/JobDocumentsStore'
import { UserContext } from 'stores/UserStore'
import { FlexView } from '../../../../components/common'
import documentIcon from '../../../../assets/icons/sre-documents-icon.svg'
import AppIcon from 'app-components/common/AppIcon'
import * as XLSX from 'xlsx'
import * as S from "./styles"
import moment from 'moment'
import { jobSchema } from './schemaData'
import { stoppagesSchema } from './schemaStoppages'
const FILE_SIZE_LIMIT = 6000000
const Ajv = require("ajv")

export const UploadDocumentButton = (props) => {
  const [file, setFile] = useState([])

  const { registryLog, registryLogOld } = useContext(UserContext)
  const { setDocumentLoaded, setfileToUpload, setJobData, setJobStoppages, isFileUploading } = useContext(JobDocumentsContext)

  const { t } = useTranslation()

  const exportFailUpload = (jobErros, stoppagesErrors) => {
    const errorJob = {
      name: 'Data',
      data: jobErros.map(e => ({
        [t('line')]: e.line,
        [t('error')]: e.field,
      }))
    }

    const errorStoppages = {
      name: 'Stoppages',
      data: stoppagesErrors.map(e => ({
        [t('line')]: e.line,
        [t('error')]: e.field,
      }))
    }

    const wb = {
      SheetNames: [errorJob.name, errorStoppages.name],
      Sheets: {
        [errorJob.name]: XLSX.utils.json_to_sheet(errorJob.data),
        [errorStoppages.name]: XLSX.utils.json_to_sheet(errorStoppages.data)
      }
    }

    const options = { bookType: 'xlsx', type: 'array' }
    document.getElementById("uploadFileInput").value = ''

    try {
      XLSX.writeFile(wb, 'failUpload-' + Date.now() + '.xlsx', options) // start downloading error file
    } catch (error) {
      console.log("error upload file new job at XLSX.writeFile()", error)
    }
  }

  const validateDateFormat = (data) => {
    const formato1 = 'DD/MM/YYYY HH:mm:ss'
    if (moment(data, formato1, true).isValid()) {
      return data
    }

    const formato2 = 'YYYY-MM-DDTHH:mm:ss.SSSZ'
    if (moment(data, formato2, true).isValid()) {
      return moment(data, formato2).format(formato1)
    }

    const formato3 = 'M/D/YY h:m'
    if (moment(data, formato3, true).isValid()) {
      return moment(data, formato3).format(formato1)
    }
    
    return null
  }

  const compileDataSchema = () => {
    const ajv = new Ajv({ allErrors: true, coerceTypes: true })
    require('ajv-errors')(ajv)

    ajv.addFormat('custom-date-time', function (dateTimeString) {
      return validateDateFormat(dateTimeString) === null ? false : true
    })

    const validate = ajv.compile(jobSchema)
    return validate
  }

  const compileStoppagesSchema = () => {
    const ajv = new Ajv({ allErrors: true, coerceTypes: true })
    require('ajv-errors')(ajv)

    ajv.addFormat('custom-date-time', function (dateTimeString) {
      return validateDateFormat(dateTimeString) === null ? false : true
    })

    const validate = ajv.compile(stoppagesSchema)
    return validate
  }

  const getError = (item, validate) => {
    const isValid = validate(item)
    return isValid ? [] : validate.errors
  }


  const hasStoppageData = (stoppages) => {
    if (stoppages.length === 0) {
      return false
    }
    let hasData = false
    const keysStoppages = Object.keys(stoppages[0])
    stoppages.forEach(stoppage => {
      keysStoppages.forEach(key => {
        if ((stoppage[key] !== null || stoppage[key] !== undefined) && stoppage[key] !== '') {
          hasData = true
          return
        }
      })
    })
    return hasData
  }

  const getErrorMessage = (dataPath, value, line, message) => {
    switch (dataPath) {
      case '/scan_date':
        if (String(value).toLowerCase() === 'downhole') {
          return { line: line + 2, field: message }
        }
        break
      case '/receive_date':
        if (String(value).toLowerCase() === 'downhole') {
          return { line: line + 2, field: message }
        }
        break
      case '/receive_status':
        if (String(value).toLowerCase() === 'downhole') {
          return { line: line + 2, field: message }
        }
        break

      default:
        return { line: line + 2, field: message }
    }
  }

  const convertExcelToJson = (f) => {
    const reader = new FileReader()

    reader.onload = function (e) {
      const data = new Uint8Array(e.target.result)
      const wb = XLSX.read(data, { type: 'array' }) // workbook]

      if (!wb.Sheets["Data"]) {
        return
      }

      const jobs = XLSX.utils.sheet_to_json(wb.Sheets['Data'], { header: 2, raw: false, dateNF: "dd/mm/yyyy", defval: null }) // [{}]
      const stoppages = XLSX.utils.sheet_to_json(wb.Sheets['Stoppages'], { header: 2, raw: false, dateNF: "dd/mm/yyyy", defval: null, blankrows: false })

      const columnB = Object.keys(wb.Sheets['Stoppages']).filter(x => /^B\d+/.test(x)).map(x => wb.Sheets['Stoppages'][x].w)
      const columnC = Object.keys(wb.Sheets['Stoppages']).filter(x => /^C\d+/.test(x)).map(x => wb.Sheets['Stoppages'][x].w)
      const columnScan = Object.keys(wb.Sheets['Data']).filter(x => /^U\d+/.test(x)).map(x => wb.Sheets['Data'][x].w)

      const stoppagesBC = columnB.map((e, i) => {
        return [e, columnC[i]]
      }).filter((_, i) => i !== 0)

      const jobsErrors = []
      const validateData = compileDataSchema()
      jobs.forEach((item, i) => {
        const lineErrors = getError(item, validateData)
        if (lineErrors.length > 0) {
          lineErrors.forEach((error) => {
            if (error.keyword === 'errorMessage') {
              const message = getErrorMessage(error.dataPath, item['location'] || item['locationStatus'], i, error.message)
              if (message?.line) {
                jobsErrors.push(message)
              }
            }
          })
        }
      })

      const stoppagesErrors = []
      if (hasStoppageData(stoppages)) {
        const validateStoppages = compileStoppagesSchema()
        stoppages.forEach((item, i) => {
          const lineErrors = getError(item, validateStoppages)
          if (lineErrors.length > 0) {
            lineErrors.forEach((error) => {
              if (error.keyword === 'errorMessage') {
                stoppagesErrors.push({ line: i + 2, field: error.message })
              }
            })
          }
        })
      }

      columnScan.forEach((scan, index) => {
        stoppagesBC.forEach((stop) => {
          if (validateDateFormat(scan) > validateDateFormat(stop[0]) && validateDateFormat(scan) < validateDateFormat(stop[1])) {
            const text = t('jobUpload.error.scanError')
            const replaced = text
              .replace("$1", scan)
              .replace("$2", stop[0])
              .replace("$3", stop[1])

            stoppagesErrors.push({ line: index, field: replaced })
          }
        })
      })

      if (jobsErrors.length > 0 || stoppagesErrors.length > 0) {
        setDocumentLoaded(false)
        exportFailUpload(jobsErrors, stoppagesErrors)
        toast.warn(t('jobUpload.error.excel'), 5000)
        return
      } else {
        setDocumentLoaded(true)
        setJobData(jobs)
        setJobStoppages(stoppages)
        setfileToUpload(file)
        registryLogOld('click_uploadDocuments', "running-expert/job-details")
        registryLog('job_details', "click", "upload_documents")
      }
    }

    reader.readAsArrayBuffer(f)
  }

  const onFileInputChange = (e) => {
    e.preventDefault()

    const files = e.target.files
    const file = files[0]

    if (file.length === 0) {
      toast.error(t("Failed to upload file. Please contact an Administrator"))
      return
    }

    if (file.size > FILE_SIZE_LIMIT) {
      toast.error(t("File is too big. Please contact an Administrator"))
      return
    }

    setFile(file)
    convertExcelToJson(file)
  }

  const onDocumentUploadClick = () => {
    document.getElementById("uploadFileInput").click()
  }

  return (
    <FlexView>
      <S.FlexWrap width="100%" alignItems="center" flexDirection='row' justifyContent="space-between">
        <S.IconButton
          isLoading={isFileUploading}
          backgroundColor="primary"
          color="white"
          onClick={onDocumentUploadClick}
        >
          <input
            type="file"
            id="uploadFileInput"
            onChange={onFileInputChange}
            hidden
          />
          <AppIcon src={documentIcon} width="24px" height="24px" />
          {t('Upload Document')}
        </S.IconButton>

        {file && <S.Subtitle>{file.name}</S.Subtitle>}
      </S.FlexWrap>
    </FlexView>
  )
}